export default function Gallery() {
    return <p className="flex grow items-center justify-center h-full">作品</p>;
}
